export default "__VITE_ASSET__9h1Kosnu__"